import React from 'react';

const PlusLabel = () => (
 <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.8045 14.7234C0.357701 14.7234 -0.00450093 14.3612 -0.00450059 13.9144C-0.00450082 13.4676 0.357702 13.1054 0.8045 13.1054L12.5806 13.1054L12.5806 1.32934C12.5806 0.882544 12.9428 0.520341 13.3896 0.52034C13.8364 0.520341 14.1986 0.882543 14.1986 1.32934L14.1986 13.1054L25.9747 13.1054C26.4215 13.1054 26.7837 13.4676 26.7837 13.9144C26.7837 14.3612 26.4215 14.7234 25.9747 14.7234H14.1986L14.1986 26.4995C14.1986 26.9463 13.8364 27.3085 13.3896 27.3085C12.9428 27.3085 12.5806 26.9463 12.5806 26.4995L12.5806 14.7234L0.8045 14.7234Z" fill="black"/>
</svg>
);

export default PlusLabel;
